import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronDownIcon } from '../utils/icons';

const Navbar = () => {
  const location = useLocation();

  // Top-level nav items
  const navItems = [
    { name: 'Dashboard', path: '/dashboard' },
    { name: 'Accounts', path: '/accounts' },
    { name: 'Budgets', path: '/budgets' },
    { name: 'Rewards', path: '/credit-card-rewards' },
  ];

  // Tools dropdown items
  const toolsItems = [
    { name: 'Savings', path: '/savings' },
    { name: 'Investments', path: '/investments' },
    { name: 'Net Worth', path: '/net-worth' },
    { name: 'Debt Management', path: '/debt-management' },
    { name: 'Money Education', path: '/money-education' },
  ];

  // Dropdown state
  const [toolsOpen, setToolsOpen] = React.useState(false);

  return (
    <nav className="inline-flex items-center relative">
      <div className="flex space-x-1">
        {navItems.map((item) => (
          <Link
            key={item.name}
            to={item.path}
            className={`px-3 py-2 text-sm font-medium rounded-md ${
              location.pathname === item.path
                ? 'bg-gray-100 text-blue-600 text-base'
                : 'text-gray-700 hover:bg-gray-50 hover:text-gray-900 text-base'
            }`}
          >
            {item.name}
          </Link>
        ))}
        {/* Tools Dropdown */}
        <div className="relative">
          <button
            type="button"
            className={`px-3 py-2 text-sm font-medium rounded-md flex items-center focus:outline-none ${toolsOpen ? 'bg-gray-100 text-blue-600' : 'text-gray-700 hover:bg-gray-50 hover:text-gray-900'}`}
            aria-haspopup="true"
            aria-expanded={toolsOpen}
            onClick={() => setToolsOpen((open) => !open)}
            onBlur={() => setTimeout(() => setToolsOpen(false), 120)}
          >
            Tools
            <ChevronDownIcon className="ml-1 h-4 w-4" aria-hidden="true" />
          </button>
          {toolsOpen && (
            <div className="absolute z-10 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
              <div className="py-1">
                {toolsItems.map((item) => (
                  <Link
                    key={item.name}
                    to={item.path}
                    className={`block px-4 py-2 text-sm ${location.pathname === item.path ? 'bg-gray-100 text-blue-600' : 'text-gray-700 hover:bg-gray-50 hover:text-gray-900'}`}
                    onClick={() => setToolsOpen(false)}
                  >
                    {item.name}
                  </Link>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
